import { useTranslation } from 'react-i18next';
import { APT_STOP_REASON_MAX_LENGTH } from '../aptStandingOrders';
import chargeStyles from '../AdditionalInfo/StandingOrderChargeDialog.module.css';
import styles from './OrderActions.module.css';

interface StopReasonFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Why a bank order is frozen or cancelled (the office, 21.10.2026: «צריך מקום לסיבת הקפאה»). Optional.
 * It goes into APT's «מצב הוראה» after the board's word, where the office writes its own reasons, so
 * it is as short as that field leaves room for.
 */
const StopReasonField = ({ id, value, onChange, disabled }: StopReasonFieldProps) => {
  const { t } = useTranslation();
  const prefix = 'standingOrders.orderActions.bank.reason';

  return (
    <div className={chargeStyles.field}>
      <label className={chargeStyles.label} htmlFor={id}>{t(`${prefix}.label`)}</label>
      <input
        id={id}
        className={chargeStyles.input}
        type="text"
        value={value}
        maxLength={APT_STOP_REASON_MAX_LENGTH}
        placeholder={t(`${prefix}.placeholder`)}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
      <span className={styles.hint}>
        {t(`${prefix}.hint`, { left: APT_STOP_REASON_MAX_LENGTH - value.length })}
      </span>
    </div>
  );
};

export default StopReasonField;
